import React from "react";
import { Box, Stack, Avatar, Typography } from "@mui/material";
import { DamsAppAsset } from "../../assets/registry";
import { DamsColors } from "../../components/styles/DamsColors";
import VerticalGap from "../../components/Gap/VerticalGap";
import Login from "./Login";
import CheckMail from "./CheckMail";
import ForgotPassword from "./ForgotPassword";
import SetPassword from "./SetPassword";
import Verification from "./Verification";

interface AuthContainerProps {
  pageState: string;
  onMainBtnClick: () => void;
  onLabelButtonClick: () => void;
  onOpenEmailAppClick: () => void;
  pageProps: any;
}

const AuthContainer: React.FC<AuthContainerProps> = ({
  pageState,
  onMainBtnClick,
  onLabelButtonClick,
  onOpenEmailAppClick,
  pageProps,
}) => {
  const renderAuthBody = () => {
    switch (pageState) {
      case "login":
        return (
          <Login
            onMainBtnClick={onMainBtnClick}
            onLabelButtonClick={onLabelButtonClick}
            pageProps={pageProps}
          />
        );
      case "forgot-password":
        return (
          <ForgotPassword
            onMainBtnClick={onMainBtnClick}
            onLabelButtonClick={onLabelButtonClick}
            pageProps={pageProps}
          />
        );
      case "create-password":
        return <SetPassword isReset={false} pageProps={pageProps} />;
      case "reset-password":
        return <SetPassword isReset pageProps={pageProps} />;
      case "check-mail":
        return (
          <CheckMail
            onOpenEmailAppClick={onOpenEmailAppClick}
            onLabelButtonClick={onLabelButtonClick}
            pageProps={pageProps}
          />
        );
      case "verify-account":
        return <Verification />;
      default:
        return null;
    }
  };

  return (
    <Box
      width={"100%"}
      height={"100vh"}
      alignContent={"center"}
      sx={styles.backgroundContainer}
    >
      <Stack
        width={"100%"}
        height={"100%"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Box
          maxWidth={520}
          borderRadius={"12px"}
          sx={styles.authFormContainer}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Stack
            m={"32px"}
            // border={'1px solid orange'}
          >
            <Stack width={456} justifyContent={"space-between"}>
              <Avatar
                src={DamsAppAsset.image.ghs_logo}
                sx={{
                  width: "48px",
                  height: "auto",
                  alignSelf: "center",
                }}
                variant="square"
              />
              <Typography
                fontSize={15}
                fontFamily={"inter"}
                fontWeight={600}
                textAlign={"center"}
                color={DamsColors.Authentication.CheckBoxLabel}
                marginTop={2}
              >
                Digital Asset Management and Maintenance System (DAMMS)
              </Typography>
              <Typography
                fontSize={30}
                fontFamily={"inter"}
                fontWeight={600}
                textAlign={"center"}
                color={DamsColors.Authentication.CheckBoxLabel}
              >
                {pageProps.pageTitle}
              </Typography>

              {pageProps.pageSubtitle && (
                <Box display={"flex"} marginTop={5}>
                  <Typography
                    fontSize={14}
                    fontFamily={"inter"}
                    fontWeight={400}
                    textAlign={"center"}
                    color={DamsColors.Authentication.CheckBoxLabel}
                    display={"flex"}
                  >
                    {pageProps?.pageSubtitle}
                  </Typography>
                  <Typography>&nbsp;</Typography>
                  <Typography
                    fontSize={14}
                    fontFamily={"inter"}
                    fontWeight={400}
                    color={DamsColors.Authentication.Button}
                  >
                    {pageState === "check-mail" && pageProps?.userEmail}
                  </Typography>
                </Box>
              )}
            </Stack>

            <VerticalGap height={20} />

            {renderAuthBody()}
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

const styles = {
  backgroundContainer: {
    backgroundImage: `url(${DamsAppAsset.image.AuthBackground})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },

  authFormContainer: {
    backgroundColor: `white`,
    borderRadius: "12px",
  },
};

export default AuthContainer;
